import { memo } from 'react'

function Skeleton({ loadingData = false }) {
  return (
    <div
      role="status"
      className={loadingData ? 'w-full mb-8 animate-pulse' : 'max-w-sm animate-pulse'}
    >
      <div
        className={
          loadingData
            ? 'h-20 bg-indigo-50 dark:bg-slate-600 dark:text-gray-200 rounded-lg w-full flex items-center justify-center text-xl'
            : 'h-10 bg-indigo-50 dark:bg-slate-600 dark:text-gray-200 rounded-lg w-full'
        }
      >
        {loadingData && 'در حال بارگزاری . . .'}
      </div>
    </div>
  )
}

export default memo(Skeleton)
